import "./styles/global.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Methodology from "./pages/Methodology";
import Services from "./pages/Services";
import IntegralSecurity from "./pages/IntegralSecurity";
import EventTypes from "./pages/EventTypes";
import Reports from "./pages/Reports";
import Technology from "./pages/Technology";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import PrivacidadApp from "./pages/PrivacidadApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/services" element={<Services />} />
          <Route path="/integral-security" element={<IntegralSecurity />} />
          <Route path="/event-types" element={<EventTypes />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
          {/* URL propia para la política de la app móvil — Google Play y
              App Store exigen un enlace directo que muestre solo esta. */}
          <Route path="/privacidad-app" element={<PrivacidadApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
